import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminUsersKeys } from 'app/queries/adminUsers/adminUsersKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminUsersKeys.detail>>;

export const createFetchAdminUserDetailsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ userId }], signal }: TParams) =>
    call(() => cancelOnSignal(AdminService.getUserDetails({ userId }), signal));
